import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
    { code: 'fr', label: 'FR' },
    { code: 'en', label: 'EN' },
    { code: 'de', label: 'DE' },
    { code: 'ch', label: 'CH' },
];

// Small flat language switcher reused on Login + in the in-game footer.
// Active language gets okbtn-primary (gold), others okbtn-secondary.
const LanguageToggle = ({ showLabel = true, size = 'sm', className = '', style }) => {
    const { i18n, t } = useTranslation();
    const current = i18n.language || 'fr';

    return (
        <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 12, ...style }}>
            {showLabel && <span className="oklbl oklbl-muted">{t('common.language')}</span>}
            <div style={{ display: 'flex', gap: 4 }}>
                {LANGS.map(({ code, label }) => (
                    <button
                        key={code}
                        type="button"
                        onClick={() => i18n.changeLanguage(code)}
                        className={`okbtn okbtn-${size === 'sm' ? 'sm' : ''} ${current.startsWith(code) ? 'okbtn-primary' : 'okbtn-secondary'}`}
                        style={{ minWidth: 44 }}
                        aria-pressed={current.startsWith(code)}
                    >
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default LanguageToggle;
